import React from 'react';
import { ToastContext } from '@signavio/ui/core';
import { PropsDecoratorProvider } from 'substyle';
import { PortalContext } from 'react-stick';
function provide(Component) {
  const ProvidedMfe = ({
    toastContext,
    portalContext,
    propsDecoratorContext,
    props
  }) => {
    return /*#__PURE__*/React.createElement(PropsDecoratorProvider, {
      value: propsDecoratorContext
    }, /*#__PURE__*/React.createElement(ToastContext.Provider, {
      value: toastContext
    }, /*#__PURE__*/React.createElement(PortalContext.Provider, {
      value: portalContext
    }, /*#__PURE__*/React.createElement(Component, props))));
  };

  // This version information will be useful for implementing backwards compatibility
  ProvidedMfe.mfeVersion = 1;
  return ProvidedMfe;
}
export default provide;
//# sourceMappingURL=provide.js.map